<template>
  <div>
    <form class="form-horizontal">
      <div
        class="form-group overflow-auto"
        style="max-height: 47vh;min-height: 30vh"
      >
        <table class="table table-hover ui-table ts-table">
          <thead>
            <tr>
              <th class="ts-whitespace-no-wrap">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.academicYear'
                  )
                }}
              </th>
              <th class="ts-whitespace-no-wrap">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.term'
                  )
                }}
              </th>
              <th class="ts-whitespace-no-wrap">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.subProgram'
                  )
                }}
              </th>
              <th class="ts-whitespace-no-wrap">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.gradeName'
                  )
                }}
              </th>
              <th class="ts-whitespace-no-wrap">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.status'
                  )
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in enrollments" :key="index">
              <td class="ts-whitespace-no-wrap">
                {{ record.ac_year }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.term_name }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.acps_name_foreign }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.grade_name_foreign }}
              </td>
              <td class="ts-justify-items-center">
                <span class="label label-green" v-if="record.ac_status_id == 1"
                  >Current</span
                >
                <span
                  class="label label-secondary"
                  v-if="record.ac_status_id == 2"
                  >History</span
                >
                <span class="label label-info" v-if="record.ac_status_id == 3"
                  >Next</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'studentProgram',
  props: ['value'],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    enrollments() {
      return this.value
    }
  }
}
</script>

<style scoped>
thead {
  position: sticky;
  z-index: 10;
  top: 0;
  overflow-y: auto;
}
</style>
